<template>
  <a
    :href="link || '#'"
    class="button"
    :class="size && sizeClass"
    @click="clickHandler"
    :target="openInNewTab ? 'blank':''"
    :rel="openInNewTab ? 'noopener noreferrer':''"
  >
    <span class="button__text">{{text}}</span>
    <img class="button__icon" v-if="icon" :src="require('@/assets/img/'+icon)" alt />
  </a>
</template>

<script>
export default {
  name: "TheButton",
  props: {
    text: String,
    icon: String,
    link: String,
    size: String,
    openInNewTab: Boolean
  },
  methods: {
    clickHandler(e) {
      if (!this.link) {
        e.preventDefault();
      }
      return;
    }
  },
  computed: {
    sizeClass() {
      const output = `button--${this.size}`;
      return output;
    }
  }
};
</script>

<style lang="scss">
.button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 242px;
  min-height: 38px;
  padding: 5px 19px;
  background-color: $black-color;
  color: $primary-color;
  font-family: $font-family-text;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  border-radius: $border-radius-btn;
  border: none;

  &--light {
    background-color: $primary-color;
    color: $black-color;

    &:hover {
      background-color: #fff;
    }
  }

  &--medium {
    width: 67%;
    min-width: 225px;
    // min-width: unset;
  }

  &:hover {
    color: $primary-color;
  }
}
</style>